/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const feedClientTypeSchema = z.enum(['ios', 'android', 'web', 'watch']);

export type IFeedClientType = z.infer<typeof feedClientTypeSchema>;

export const getFeedV3RequestSchema = z.object({
  cursor: z.string().optional(),
  type: feedClientTypeSchema,
});

export type IGetFeedV3Request = z.infer<typeof getFeedV3RequestSchema>;
